/* eslint-disable no-redeclare */
import {
  DomainUserId,
  Email,
  SessionId,
  UserId,
  UUID,
} from '@hc-frontend/core-types';
import { z } from 'zod';

const BlueshiftEventName = z.enum(['hc_contact']);

const BlueshiftEventLanding = z.enum(['MEDICARE_HC_COM', 'HEALTHCARE_INSIDER']);

const BlueshiftProductActual = z.enum(['Medicare', 'Health']);

export const SendBlueshiftEventRequest = z.object({
  event: BlueshiftEventName,
  event_source: z.literal('apollo'),
  domain_source: z.enum(['Healthcare', 'Medicare']),
  hc_last_join: z.string().datetime(),
  traffic_source: z.literal('subsidy-calculator'),
  customer_id: UUID,
  hc_user_id: UserId,
  healthcare_session: SessionId,
  on: z.string().datetime(),
  domain_user_id: DomainUserId,
  product_landing: BlueshiftEventLanding,
  hc_pharmacy_interested: z.literal('unknown'),
  product_actual: BlueshiftProductActual,
  email: Email,
  birthdate: z.string(),
  birth_dayofmonth: z.number().int().min(1).max(31),
  birth_month: z.number().int().min(1).max(12),
  birth_year: z.number().int().min(1900).max(2100),
});

export type SendBlueshiftEventRequest = z.infer<
  typeof SendBlueshiftEventRequest
>;
